<div class="page-description-wrapper">
  <div class="container">
    <p class="page-description">
      @if(!fatherPageDescriptionEnabled){
      Discover top-quality parts at <a class="link no-underline grey weight-500"  [routerLink]="'/'+vehicleTypeService?.currentVehicleType" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>Fastparts
          shop</b></a>, your premier destination for auto car replacement parts. Our extensive selection ensures you
      find the perfect parts for any vehicle, including Toyota, Dacia, Volkswagen, Hyundai, Kia, Suzuki, Nissan, Skoda,
      Ford, BMW, Mercedes-Benz.<br /><br />
      At <a class="link no-underline grey weight-500"  [routerLink]="'/'+vehicleTypeService?.currentVehicleType" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>Fastparts shop</b></a>, we prioritize
      customer satisfaction by providing best quality parts at competitive prices. Enjoy an easy checkout process,
      access your order history when logged in, and benefit from our dedicated support. Enjoy fast shipping, expert
      advice, and hassle-free returns on all orders. Upgrade your vehicle today with premium parts from <a
        class="link no-underline grey weight-500"  [routerLink]="'/'+vehicleTypeService?.currentVehicleType" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>Fastparts shop</b></a>, and ensure your
      vehicle’s safety and performance with the best parts in market.
      } @else {
      <ng-content></ng-content>
      }
    </p>
  </div>
</div>
